import { useMemo, useState,useRef } from "react";

const makeid = (length) => {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const CollapseMenu = ({ title, children, showItems = false }) => {
  const [showing, setShowing] = useState(showItems);

  const key = useMemo(() => makeid(16), []);

  const contentRef = useRef(null);

  const style = {
    transform: showing ? "rotate(-90deg)" : "",
    transition: "transform 150ms ease", // smooth transition
    height: "12px",
    
  };

  const handleToggle = () => {
    setShowing(!showing);
//accordion toggle event added
    if (contentRef.current) {
      contentRef.current.style.height = showing ? "0" : `${contentRef.current.scrollHeight}px`;
    }
  };

  return (
    <div className="border-b border-[##DCDCDC]">
      <div className="mt-[8px] lg:mt-[16px]">
        <div
          className="row-between cursor-pointer pb-[16px] lg:pb-[24px]"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${key}`}
          aria-expanded="false"
          aria-controls={`${key}`}
          onClick={handleToggle}
        >
          <h3
            className="title font-bold"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <img
            style={style}
            alt="right"
            src="/images/include/chevron-right.png"
            className="h-[12px] w-auto"
          />
        </div>
      </div>

      <div className={`${showing ? "visible" : "collapse"}`} id={`${key}`} ref={contentRef} style={{
          height: showing ? `${contentRef.current?.scrollHeight}px` : "0",
          overflow: "hidden",
          transition: "height 150ms ease",
        }}>
        {typeof children === "string" ? (
          <div
            className="block pb-6 pt-0"
            dangerouslySetInnerHTML={{ __html: children }}
          />
        ) : (
          <div className="block pb-6 pt-0">{children}</div>
        )}
      </div>
    </div>
  );
};

export default CollapseMenu;
